(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Mobile drawer */
  var drawer = $('[data-drawer]');
  if (drawer) {
    $$('[data-nav-open]').forEach(function (b) { b.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; }); });
    $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', function () { drawer.hidden = true; document.body.style.overflow = ''; }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; } });
  }

  /* Hero slider */
  $$('[data-slider]').forEach(function (root) {
    var slides = $$('[data-slide]', root), dots = $$('[data-dot]', root), i = 0, timer;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() {
      if (root.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(function () { go(i + 1); }, parseInt(root.dataset.delay, 10) || 6000);
    }
    var p = $('[data-prev]', root), n = $('[data-next]', root);
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (n) n.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); play(); }); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    play();
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!m) return;
    var wrap = m.closest('.qty'), input = $('input', wrap);
    var min = parseInt(input.min || '0', 10), v = parseInt(input.value || '0', 10);
    v = m.hasAttribute('data-qty-plus') ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Auto-submit sort select */
  $$('[data-auto-submit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });

  /* Cart count helper */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }

  /* Product page */
  $$('[data-product]').forEach(function (root) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    var form = $('#ProductForm', root), idInput = $('[data-variant-id]', root);
    var selects = $$('[data-option]', root), priceEl = $('[data-price]', root), cmpEl = $('[data-compare]', root);
    var addBtn = $('[data-add]', root), addLabel = $('[data-add-label]', root), stockEl = $('[data-stock]', root), skuEl = $('[data-sku]', root);
    var errEl = $('[data-error]', root);
    var T = window.NORA_STRINGS || {};

    function current() {
      var vals = selects.map(function (s) { return s.value; });
      if (!vals.length) return variants[0];
      return variants.filter(function (v) { return vals.every(function (x, k) { return v.options[k] === x; }); })[0];
    }
    function update() {
      var v = current();
      if (!v) { addBtn.disabled = true; if (addLabel) addLabel.textContent = T.unavailable || 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_f;
      if (cmpEl) { if (v.compare && v.compare > v.price) { cmpEl.hidden = false; cmpEl.textContent = v.compare_f; } else cmpEl.hidden = true; }
      addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? (T.add || 'Add to cart') : (T.sold || 'Sold out');
      if (stockEl) stockEl.textContent = v.available ? (T.inStock || 'In stock') : (T.sold || 'Sold out');
      if (skuEl) skuEl.textContent = v.sku || '';
      if (v.media) showMedia(v.media);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });

    /* gallery */
    var slides = $$('[data-slide-media]', root), thumbs = $$('[data-thumb]', root);
    function showMedia(id) {
      slides.forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.slideMedia) === String(id)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

    /* ajax add to cart */
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      errEl.hidden = true;
      var fd = new FormData(form);
      addBtn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { errEl.textContent = res.j.description || res.j.message || 'Error'; errEl.hidden = false; addBtn.disabled = false; return; }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            setCount(c.item_count);
            if (addLabel) { var old = addLabel.textContent; addLabel.textContent = T.added || 'Added ✓'; setTimeout(function () { addLabel.textContent = old; addBtn.disabled = false; }, 1600); }
            var fl = $('.floater--cart'); if (fl) { fl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 400 }); }
          });
        })
        .catch(function () { form.submit(); });
    });

    /* related products (section rendering) */
    var recs = $('[data-recs-url]', root.parentNode) || $('[data-recs-url]');
    if (recs && !$('.section--soft')) {
      fetch(recs.dataset.recsUrl).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), sec = d.querySelector('.section--soft');
        if (sec) root.insertAdjacentElement('afterend', sec);
      }).catch(function () {});
    }
  });

  /* Cart page: submit on qty change */
  var cartForm = $('#CartForm');
  if (cartForm) {
    var t;
    $$('.cart-row__qty input', cartForm).forEach(function (inp) {
      inp.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { var b = document.createElement('input'); b.type = 'hidden'; b.name = 'update'; b.value = '1'; cartForm.appendChild(b); cartForm.submit(); }, 700); });
    });
  }
})();
